// extracted by mini-css-extract-plugin
export default {"primaryBtn":"buttons_primaryBtn__DYMTs","btn":"buttons_btn__NosOk","secondaryBtn":"buttons_secondaryBtn__tyHg4","active":"buttons_active__oqL2N"};